module.exports = __webpack_public_path__ + "static/media/typeC.50d864c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/hero/typeC.png
// module id = 1219
// module chunks = 0